import axios from 'axios';

export const fetchChiefdomList = (districtId: number) =>
  axios({
    method: 'GET',
    url: '/user-service/user/tagged-chiefdoms',
    params: {
      districtId
    }
  });
